"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorageState = exports.createDeleteLocalStorageState = void 0;
var _react = require("react");
var _localforage = _interopRequireDefault(require("localforage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var createDeleteLocalStorageState = storageKey => /*#__PURE__*/_asyncToGenerator(function* () {
  yield _localforage.default.removeItem(storageKey);
});
exports.createDeleteLocalStorageState = createDeleteLocalStorageState;
var useLocalStorageState = storageKey => {
  var [state, setState] = (0, _react.useState)({});
  var [stateLoading, setStateLoading] = (0, _react.useState)(true);
  var updateState = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (newState) {
      yield _localforage.default.setItem(storageKey, newState);
      setState(newState);
    });
    return function updateState(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  function init() {
    return _init.apply(this, arguments);
  }
  function _init() {
    _init = _asyncToGenerator(function* () {
      var localForm = yield _localforage.default.getItem(storageKey);
      if (!localForm) localForm = yield _localforage.default.setItem(storageKey, {});
      setState(_objectSpread({}, localForm));
      setStateLoading(false);
    });
    return _init.apply(this, arguments);
  }
  (0, _react.useEffect)(() => {
    init();
  }, []);
  var deleteState = createDeleteLocalStorageState(storageKey);
  return {
    state,
    updateState,
    stateLoading,
    deleteState
  };
};
exports.useLocalStorageState = useLocalStorageState;